<template>
  <!--
    Yodlee's FastLink script injects its own iframe into #containerId, so this
    dialog is a frame around foreign content: no padding, no header, and
    dismissal is disabled — closing has to go through handleClose so
    fastlink.close() runs and the widget tears itself down.
  -->
  <DSDialog
    :open="isOpen"
    @update:open="handleUpdateOpen"
  >
    <DSDialogContent
      class="max-w-ds-dialog-xl gap-0 p-0"
      @escape-key-down.prevent
      @pointer-down-outside.prevent
      @interact-outside.prevent
    >
      <DSDialogHeader class="sr-only">
        <DSDialogTitle>Connect through Yodlee</DSDialogTitle>
        <DSDialogDescription>
          Yodlee FastLink opens here to authorise your institution.
        </DSDialogDescription>
      </DSDialogHeader>

      <div
        :id="containerId"
        data-container="yodlee-container"
        class="relative min-h-96"
      >
        <div class="absolute inset-0 -z-10 flex flex-col items-center justify-center gap-3">
          <LoaderCircle class="size-6 animate-spin text-muted-foreground" />
          <span class="text-sm font-medium text-muted-foreground">
            Loading Yodlee…
          </span>
        </div>
      </div>
    </DSDialogContent>
  </DSDialog>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'
import { LoaderCircle } from '@lucide/vue'

import { ModalClass } from '@types'

import {
  DSDialog,
  DSDialogContent,
  DSDialogDescription,
  DSDialogHeader,
  DSDialogTitle,
} from '@ds'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)

const containerId = computed(
  () => `container-fastlink-${getCurrentInstance()?.uid.toString()}`,
)

const handleClose = () => {
  props.modal.close()
  ;(window as Window & typeof globalThis & { fastlink: any }).fastlink.close()
}

const handleUpdateOpen = (value: boolean) => {
  if (!value) handleClose()
}
</script>
